import { Theme } from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import * as React from 'react';
import { connect } from 'react-redux';
import { ProofRequestStatus } from '../../../../../../data-types/user/userEnums';
import { ProofRequest } from '../../../../../../data-types/user/userInterfaces';
import { TStore } from '../../../../../../state/store';

interface Props {
  proofRequests: ProofRequest[];
}

class VerificationRequestsCountBadge extends React.Component<Props & WithStyles<typeof styles>> {
  private getProofRequestsThatRequiresUsersAttentionNumber = () => {
    const { proofRequests } = this.props;

    const proofRequestsThatRequiresUsersAttention = proofRequests.filter(
      request => request.status === ProofRequestStatus.PENDING || request.status === ProofRequestStatus.NEEDS_FURTHER_WORK,
    );
    return proofRequestsThatRequiresUsersAttention.length;
  };

  public render(): React.ReactNode {
    const { classes, proofRequests } = this.props;

    return proofRequests.length > 0 ? (
      <div data-testid="verification-requests-count-badge" className={classes.root}>
        <span data-testid="verification-requests-count-badge-number-text" className={classes.text}>
          {this.getProofRequestsThatRequiresUsersAttentionNumber()}
        </span>
      </div>
    ) : null;
  }
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.error.main,
      borderRadius: '50%',
      textAlign: 'center',
      minWidth: 24,
      minHeight: 24,
    },
    text: {
      fontSize: 14,
    },
  });

const mapStateToProps = (store: TStore) => ({
  proofRequests: store.userData.proofRequests,
});

export default connect(mapStateToProps)(withStyles(styles)(VerificationRequestsCountBadge));
